import React, { useState } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { useApp } from "../context/AppContext";
import { resetPassword } from "../services/api";
import Seo from "../components/Seo";
import { KeyRound, CheckCircle2 } from "lucide-react";

export default function ResetPassword() {
  const { t, lang } = useApp();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pw !== pw2) { setError(t("auth.pwMismatch")); return; }
    setLoading(true);
    try {
      await resetPassword(token, pw);
      setDone(true);
      setTimeout(() => navigate("/login"), 3000);
    } catch {
      setError(t("auth.resetError"));
    }
    setLoading(false);
  };

  return (
    <div className="pt-20 min-h-screen bg-cream flex items-start justify-center">
      <Seo title={t("auth.resetTitle")} description={t("auth.resetTitle")} path="/reset-password" lang={lang} noindex />
      <div className="w-full max-w-md mx-auto px-6 py-16" data-testid="reset-password-page">
        <div className="text-center mb-8">
          <div className="w-14 h-14 mx-auto rounded-full bg-wine flex items-center justify-center mb-4"><KeyRound className="w-6 h-6 text-gold" /></div>
          <h1 className="font-serif text-3xl text-ink">{t("auth.resetTitle")}</h1>
        </div>
        {done ? (
          <div className="bg-green-50 border border-green-200 rounded-2xl p-6 text-center" data-testid="reset-success">
            <CheckCircle2 className="w-8 h-8 mx-auto text-green-600 mb-3" />
            <p className="text-green-800 text-sm">{t("auth.resetSuccess")}</p>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <Input data-testid="reset-password-input" type="password" value={pw} onChange={(e) => setPw(e.target.value)} placeholder={t("auth.newPassword")} required minLength={6} className="bg-white h-12" />
            <Input data-testid="reset-password-confirm" type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} placeholder={t("auth.confirmPassword")} required minLength={6} className="bg-white h-12" />
            {error && <p data-testid="reset-error" className="text-sm text-destructive">{error}</p>}
            <Button data-testid="reset-submit-button" type="submit" disabled={loading || !token} className="w-full bg-wine hover:bg-wine-dark text-white h-12 text-base">
              {loading ? "…" : t("auth.resetCta")}
            </Button>
            {!token && <p className="text-sm text-destructive text-center">{t("auth.resetError")}</p>}
          </form>
        )}
        <p className="text-center text-sm text-ink/50 mt-8">
          <Link to="/login" className="hover:text-wine underline underline-offset-4">{t("auth.backToLogin")}</Link>
        </p>
      </div>
    </div>
  );
}
